export default __webpack_public_path__ + "static/media/sui.6dfaa12f.svg";